export default function CompareData() {
  return {
    title: "Difference Between Term and Permanent Life Insurance",
    description: "The key difference between term life insurance and permanent life insurance is the duration of coverage and the presence of a cash value component.",
    products: [
      {
        productName: "Term life Insurance",
        description: "provides coverage for a specific period, such as 10, 20, or 30 years, and pays a death benefit only if the policyholder dies during that term. It is generally more affordable and straightforward.",
        buttonText: "See Your Quotes",
        action: {type: "submit"},
      },
      {
        productName: "Permanent life insurance",
        description: "on the other hand, offers lifelong coverage and includes a cash value component that grows over time, which the policyholder can borrow against or use as savings. However, permanent life insurance tends to have higher premiums due to these additional features.",
        buttonText: "Explore Permanent",
        action: {type: "redirect", location: "/landing/permanent"},
      },
    ]
  };
};